export const ListQueryKey = 'projectExamples';
export const DetailQueryKey = 'projectExample';

export const Urls = {
  selectUrl: '/projectExample/list',
  updateUrl: '/projectExample/update',
  deleteUrl: '/projectExample/delete',
  createUrl: '/projectExample/create',
  detailUrl: '/projectExample/detail',
};
